module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"dk":{"enterEmailToResetPassword":"Indtast venligst din e-mail for at modtage et link til nulstilling af din adgangskode.","checkEmail":"Kontroller din mail for yderligere instruktioner.","passwordRequestSubmitted":"Adgangskoden blev ændret. Du bliver nu omdirigeret til login-siden...","newPassword":"Ny Adgangskode","confirmPassword":"Bekræft adgangskode"}}')
  delete Component.options._Ctor
}
